import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoClassPresupuestaria from '../../catalogos/catalogoClassPresupuestario';

export const ImprimirDisponibilidadporPartidas = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [parameter, setParameter] = useState('');
    const [mostrar4, setMostrar4] = useState(false);
    const [fecha, setFecha] = useState('');
    const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [cata, setCata] = useState(0);
    const [valor1, setValor1] = useState('00');
    const [valor2, setValor2] = useState('00');
    const [valor3, setValor3] = useState('00');
    const [valor4, setValor4] = useState('00');
    const [valor5, setValor5] = useState('0000');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtFecha = useRef();
    const txtChk1 = useRef();
    const txtChk2 = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtFecha.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Fecha!', icono: 'informacion' });
            sigue = false;
            txtFecha.current.focus();
        }

        else if (sigue) {
            imprimirGeneral(fecha, parameter)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'fecha') {
            setFecha(e.target.value);
        }
    };

    const onCheck = () => {

        if (txtChk1.current.checked) {
            setCata(1);
            setVal(400000000);
            setVal2(999999999);
        } else if (txtChk2.current.checked) {
            setCata(0);
            setVal(400000000);
            setVal2(999999999);
            setActivo(false);
            setParameter("");
        }

    }

    const imprimirGeneral = (fecha, valida) => {

        let fech = moment.utc(fecha).format('DD-MM-YYYY');
        var sql2 = "";
        if (valida !== "") {
            sql2 = "BETWEEN " + "'"+valida+"'" + " AND  " + "'"+valida+"'";
        } else {
            sql2 = "BETWEEN '400000000' AND '499999999'";
        }

        var reporte = "Disponibilidad_Partidas";
        let condi = "Al Día " + fech;

        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + sql2 + "&sql3=" + "'" + fech + "'" + "&sql4=" + condi, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtFecha.current.value = '';
        setActivo(true);
        setMostrar4(false);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const handleAceptaClasPresupuestaria = (idpuc, descripcion, puc) => {
        setMostrar4(false);
        console.log(puc);
        setValor1(puc.substring(0, 3));
        setValor2(puc.substring(3, 5));
        setValor3(puc.substring(5, 7));
        setValor4(puc.substring(7, 9));
        setActivo(false);
        setParameter(puc);
    }

    return (
        <Modal
            {...props}
            size="lx"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtFecha.current.value = fech;
                setFecha(fech);

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir Disponilibidad por Partidas'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoClassPresupuestaria
                    show={mostrar4}
                    val={val}
                    vals={val2}
                    onHideCancelar={handleCancelaras}
                    onHideAceptaClasPresupuestaria={handleAceptaClasPresupuestaria}
                />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                            <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-6 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Al Día:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtFecha} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="fecha" />
                                        </div>
                                    </div>

                                </div>

                                <div className='row m-0 px-0 col-md-11 mx-auto mb-2'>
                                    <div className="form-check col-md-6 ml-auto">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Seleccionar Partida
                                        </label>
                                    </div>
                                    <div className="form-check col-md-5 ml-auto">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Todas las Partidas
                                        </label>
                                    </div>
                                </div>

                                {cata !== 0 ? <div className='col-md-12 m-0 px-0'>
                                    <table className="table">
                                        <thead>
                                            <tr className='text-center'>
                                                <th scope="col">Ramo</th>

                                                <th scope="col">Gen</th>

                                                <th scope="col">Espec</th>

                                                <th scope="col">SubEsp</th>

                                                <th scope="col">Auxiliar</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-bordered'>
                                            <tr className='text-center'>
                                                <td>{valor1}</td>

                                                <td>{valor2}</td>

                                                <td>{valor3}</td>

                                                <td>{valor4}</td>

                                                <td>{valor5}</td>

                                                <td><button onClick={catalogoClass} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> : ''}


                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}